const getters = {
    orderStatus: state => state.orderStatus,
    orderErrors: state => state.orderErrors,
    orders: state => state.orders,
    payments: state => state.payments,
    ordersCount: state => state.ordersCount,
    paymentsCount: state => state.paymentsCount,
    orderDetailById: (state) => (id) => {
        return state.orders.find(order => order.o_id === id)
    },
}

export default getters
